import { TreeSelectSelectionKeys, ZCDTreeSelect } from '@zencity/common-ui';
import React, { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldTitle } from 'screens/WidgetGenerator/components/FieldTitle/FieldTitle';
import { ReportFilterProps } from 'screens/WidgetGenerator/reportGeneratorComponents/types';
import { mapDivisionsTreeToFilterOptions } from './utils';

type Props = ReportFilterProps<number | undefined>;

/**
 * A tree-select filter component with Divisions data.
 */
export const GeographicDivisionsFilter: React.FC<Props> = function GeographicDivisionsFilter(
  props: Props,
): ReactElement {
  const { value: filterValue, onChange, filterValues, clientData } = props;
  const { t: translate } = useTranslation();

  const divisionTree = useMemo(() => {
    if (!filterValues.surveyGroupId) {
      return undefined;
    }
    const surveyGroup = clientData.surveysGroups.find((instance) => instance.id === filterValues.surveyGroupId);
    if (!surveyGroup) {
      return undefined;
    }
    return clientData.divisionTreeBySurveyType[surveyGroup.type];
  }, [filterValues.surveyGroupId, clientData.divisionTreeBySurveyType, clientData.surveysGroups]);

  const geographicDivisionFilterOptions = useMemo(() => {
    if (!divisionTree) {
      return [];
    }

    return mapDivisionsTreeToFilterOptions(divisionTree);
  }, [divisionTree]);

  const handleClick = (event: { value: TreeSelectSelectionKeys }) => {
    onChange(event.value as unknown as number);
  };

  return (
    <>
      <FieldTitle title={translate('widgetGenerator.selectDivision')} />
      <ZCDTreeSelect
        disabled={!geographicDivisionFilterOptions?.length}
        options={geographicDivisionFilterOptions}
        value={filterValue?.toString()}
        showSearch
        selectionMode="single"
        searchPlaceholder={translate('widgetGenerator.geographicAreasFilter.searchPlaceholder')}
        placeholder={translate('widgetGenerator.geographicAreasFilter.placeholder')}
        onChange={handleClick}
        onClearValue={() => {
          onChange(undefined);
        }}
      />
    </>
  );
};
